<mat-toolbar color="primary">
  <span id="møte-opprett-dialog-tittel">
    @if (skjema.controls.gruppe.value) {
      {{ "Opprett {moetenavn} i {gruppetittel} ({organisasjonsnavn})"|translate: {moetenavn: skjema.controls.gruppe.value.moetenavn, gruppetittel: skjema.controls.gruppe.value.tittel, organisasjonsnavn: skjema.controls.gruppe.value.organisasjonsnavn} }}
    } @else {
      {{ "Opprett nytt møte"|translate }}
    }
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

<mat-stepper linear="true" class="e2e-nyttmoeteskjema" data-testid="nyttmøteskjema" #steg>
  <mat-step [stepControl]="skjema" label="{{'Møtedetaljer'|translate}}">
    <form [formGroup]="skjema" class="e2e-steg-møtedetaljer">
      <mat-dialog-content #skjemaKontainerDetaljer>
        <h2>{{ "Legg inn møtedetaljer"|translate }}</h2>
        <mat-form-field class="gruppevelger">
          <mat-label>{{ "Gruppe"|translate }}</mat-label>
          <velg-gruppe [skjemakontroll]="skjema.controls.gruppe!" [grupper]="grupper()"/>
        </mat-form-field>
      <moete-rediger-detaljer [skjema]="skjema.controls.detaljer!" [fokuserStartdatoFelt]="fokuserStartdatoFelt()" [gruppeId]="valgtGruppe()?.id ?? null" />
      </mat-dialog-content>
      <mat-dialog-actions>
        <div class="scrollvarsel" [visDersomIkkeScrolletTilBunn]="skjemaKontainerDetaljer" klasseNaarSynlig="scrollvarsel-synlig"><span>{{ 'Scroll ned for å se resten av skjemaet...' | translate }}</span></div>
        <div class="handlinger">
          <div class="senter">
            <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
            <button mat-raised-button color="primary" cdkFocusInitial matStepperNext [disabled]="skjema.invalid" class="e2e-neste-steg" data-testid="neste">
              {{ "Neste"|translate }}
            </button>
          </div>
          <button (click)="redigerMoetemal()" [disabled]="valgtGruppe() == null" mat-button color="primary" type="button" class="høyre e2e-rediger-møtemal">
            {{ "Rediger møtemal"|translate }}
          </button>
        </div>
      </mat-dialog-actions>
    </form>
  </mat-step>

  <mat-step [stepControl]="skjema" optional="true" label="{{'Saker'|translate}}">
    <form [formGroup]="skjema" class="e2e-steg-saker">
      <mat-dialog-content #skjemaKontainerSaker>
        <h2>{{ "Hvilke saker skal behandles i møtet?"|translate }}</h2>
        <div class="saker">
          <moete-opprett-inkluderte-saker [skjema]="skjema.controls.saker" [malsaker]="malmoete()?.saker ?? []"/>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <div class="scrollvarsel" [visDersomIkkeScrolletTilBunn]="skjemaKontainerSaker" klasseNaarSynlig="scrollvarsel-synlig"><span>{{ 'Scroll ned for å se resten av skjemaet...' | translate }}</span></div>
        <div class="handlinger">
          <div class="senter">
            <button mat-button matStepperPrevious>{{ "Tilbake"|translate }}</button>
            <button mat-raised-button color="primary" cdkFocusInitial matStepperNext class="e2e-neste-steg">{{ "Neste"|translate }}</button>
          </div>
          <button (click)="redigerMoetemal()" [disabled]="valgtGruppe() == null" mat-button color="primary" type="button" class="høyre e2e-rediger-møtemal">
            {{ "Rediger møtemal"|translate }}
          </button>
        </div>
      </mat-dialog-actions>
    </form>
  </mat-step>

  @if (erGeneralforsamling()) {
    <mat-step [stepControl]="skjema.controls.aksjeeiere" optional="false" label="{{'Representasjon'|translate}}">
      <form [formGroup]="skjema" class="e2e-steg-representasjon">
        <mat-dialog-content #skjemaKontainerRepresentasjon>
          <h2>{{ "Representasjon"|translate }}</h2>
          <div class="representasjon">
            <generalforsamling-rediger-representasjoner [skjema]="skjema.controls.aksjeeiere" [gruppe]="valgtGruppe()!" [standardAksjeeierRolle]="standardAksjeeierRolle()"/>
          </div>
        </mat-dialog-content>
        <mat-dialog-actions>
          <div class="scrollvarsel" [visDersomIkkeScrolletTilBunn]="skjemaKontainerRepresentasjon" klasseNaarSynlig="scrollvarsel-synlig"><span>{{ 'Scroll ned for å se resten av skjemaet...' | translate }}</span></div>
          <div class="handlinger">
            <div class="senter">
              <button mat-button matStepperPrevious>{{ "Tilbake"|translate }}</button>
              <button mat-raised-button color="primary" cdkFocusInitial matStepperNext [disabled]="skjema.controls.aksjeeiere.invalid" class="e2e-neste-steg">{{ "Neste"|translate }}</button>
            </div>
            <button (click)="redigerMoetemal()" [disabled]="valgtGruppe() == null" mat-button color="primary" type="button" class="høyre e2e-rediger-møtemal">
              {{ "Rediger møtemal"|translate }}
            </button>
          </div>
        </mat-dialog-actions>
      </form>
    </mat-step>
  }

  <mat-step [stepControl]="skjema" optional="true" label="{{'Deltakere'|translate}}">
    <form [formGroup]="skjema" class="e2e-steg-deltakere">
      <mat-dialog-content #skjemaKontainerDeltakere>
        <h2>{{ "Hvem skal delta på møtet?"|translate }}</h2>
        <div class="deltakere">
          @if (erGeneralforsamling()) {
            <moete-rediger-deltakere-gf [deltakereSkjema]="skjema.controls.deltakere" [representasjonerSkjema]="skjema.controls.aksjeeiere" (vedGaaTilRepresentasjonSteg)="gaaTilRepresentasjonSteg()"/>
          } @else {
            <moete-rediger-deltakere [skjema]="skjema.controls.deltakere"/>
          }
          <moete-rediger-eksterne-deltakere [skjema]="skjema.controls.eksterneDeltakere"/>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions align="center">
        <div class="scrollvarsel" [visDersomIkkeScrolletTilBunn]="skjemaKontainerDeltakere" klasseNaarSynlig="scrollvarsel-synlig"><span>{{ 'Scroll ned for å se resten av skjemaet...' | translate }}</span></div>
        <div class="handlinger">
          <div class="senter">
            <button mat-button matStepperPrevious>{{ "Tilbake"|translate }}</button>
            <button mat-raised-button color="primary" cdkFocusInitial matStepperNext class="e2e-neste-steg">{{ "Neste"|translate }}</button>
          </div>
          <button (click)="redigerMoetemal()" [disabled]="valgtGruppe() == null" mat-button color="primary" type="button" class="høyre e2e-rediger-møtemal">
            {{ "Rediger møtemal"|translate }}
          </button>
        </div>
      </mat-dialog-actions>
    </form>
  </mat-step>

  <mat-step [stepControl]="skjema" label="{{'Publisering'|translate}}">
    <form [formGroup]="skjema" (ngSubmit)="lagre()" class="e2e-steg-publisering">
      <mat-dialog-content>
        <h2>{{ "Hva skal publiseres?"|translate }}</h2>
        <div class="publisering">
          <moete-opprett-publisering [skjema]="skjema.controls.publisering" [gruppemedlemmer]="skjema.value.gruppe?.medlemmer ?? null" [antallDeltakere]="antallDeltakere()"/>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions align="center">
        <div class="handlinger">
          <div class="senter">
            <button mat-button matStepperPrevious>{{ "Tilbake"|translate }}</button>
            <!-- har ikke med disabled=skjema.invalid da skjema ikke kan være ugyldig når man kommer til dette steget -->
            <button mat-raised-button type="submit" color="primary" cdkFocusInitial [visSpinner]="lagrer()" [disabled]="lagrer()" spinnerTekst="{{'Lagrer...'|translate}}" class="e2e-opprett-møte">
              {{ "Opprett møte ({antall} saker)"|translate: {antall: antallSaker()} }}
            </button>
          </div>
          <button (click)="redigerMoetemal()" [disabled]="valgtGruppe() == null" mat-button color="primary" type="button" class="høyre e2e-rediger-møtemal">
            {{ "Rediger møtemal"|translate }}
          </button>
        </div>
      </mat-dialog-actions>
    </form>
  </mat-step>
</mat-stepper>
